<div class="nfd-card">
  <span class="nfd-title" id="nfd-title">Filter</span>
  <div class="nfd-list" role="group" aria-labelledby="nfd-title">
    @for (opt of options; track opt.value) {
      <button
        class="nfd-option"
        type="button"
        [attr.aria-pressed]="activeFilter === opt.value"
        (click)="select(opt.value)"
      >
        <i class="bi nfd-icon" [class]="opt.icon" aria-hidden="true"></i>
        <span class="nfd-label">{{ opt.label }}</span>
      </button>
    }
  </div>
</div>
